<!--
 * @Author: 田鑫
 * @Date: 2022-01-10 17:33:14
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-13 21:18:31
 * @Description: 物美优选
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item>物美优选</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="广告名称：" prop="adName">
          <el-input style="width: 300px" v-model="listParams.adName" placeholder="请填写广告名称"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData(true)" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="openDialog('')" type="primary">新增</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
            </template>
          </el-table-column>
          <el-table-column label="广告名称" prop="adName" align="center"></el-table-column>
          <el-table-column label="广告banner" prop="imgUrl" align="center">
            <template slot-scope="scope">
              <el-image :src="scope.row.imgUrl" :preview-src-list="[scope.row.imgUrl]" style="max-width: 120px; max-heightl: 80px; border-radius: 6px"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该广告吗？" @confirmed="deleteItem(scope.row.id)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" @close="$refs['dialogForm'].resetFields()" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" label-width="120px">
        <el-form-item label="广告名称：" prop="adName">
          <el-input v-model="dialogForm.adName" placeholder="请填写广告名称" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="广告主图：" prop="imgUrl">
          <oss-uploader :sizeLimit="2" @setImage="getImage" :previewList="previewList"></oss-uploader>
        </el-form-item>
        <el-form-item label="详情：" prop="content">
          <RichTextarea v-if="dialogVisible" class="wang-editor-style" v-model="dialogForm.content" />
        </el-form-item>
        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button @click="saveDialog('dialogForm')" type="primary" :disabled="isDisabled">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        adName: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      dialogForm: {
        adName: "",
        imgUrl: "",
        content: "",
      },
      dialogRules: {
        adName: [{ required: true, message: "请填写广告名称", trigger: "blur" }],
        imgUrl: [{ required: true, message: "请上传广告主图", trigger: "chagne" }],
        content: [{ required: true, message: "请填写广告详情", trigger: "blur" }],
      },
      isDisabled: false,
      previewList: [],
      method: "",
      url: "",
    };
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.loadTableData();
  },
  //生命周期 - 方法
  methods: {
    /**
     * @description: 加载列表
     * @param {*} isReset
     * @return {*}
     */
    loadTableData(isReset) {
      if (isReset) {
        this.pager.pageIndex = 1;
      }
      this.tableLoading = true;
      let bodyParams = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/ad/adList",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 编辑厨师
     * @param {*} id
     * @return {*}
     */
    editItem(id) {
      this.$http({
        url: global.apiUrl + "/ad/adDetail",
        method: "GET",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.dialogForm, res.body.data);
            if (this.dialogForm.imgUrl) {
              this.previewList = [this.dialogForm.imgUrl];
            }
            this.openDialog(id);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 删除厨师
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/ad/deleteAd",
        method: "DELETE",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 打开弹框
     * @param {*} id
     * @return {*}
     */
    openDialog(id) {
      if (id) {
        this.method = "PUT";
        this.url = "/ad/editAd";
      } else {
        //* 还原表单
        this.dialogForm = this.$options.data().dialogForm;
        this.previewList = [];
        this.method = "POST";
        this.url = "/ad/addAd";
      }
      this.dialogVisible = true;
    },
    /**
     * @description: 获取图片
     * @param {*} file
     * @return {*}
     */
    getImage(file) {
      this.dialogForm.imgUrl = file;
    },
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    saveDialog(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = JSON.parse(JSON.stringify(Object.assign(this.dialogForm)));
          this.isDisabled = true;
          this.$http({
            url: global.apiUrl + this.url,
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              this.isDisabled = false;
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.dialogVisible = false;
                //* 还原表单
                this.dialogForm = this.$options.data().dialogForm;
                this.previewList = [];
                this.loadTableData();
              } else {
              }
            })
            .catch(err => {
              this.isDisabled = false;
              console.error(err);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
